<template>
  <div class="card-form">
    <div style="margin-top:10px;">
      <page-header
        slot="header"
        @reset="reset"
        @submit="handleSubmit"
        @openCart="openCart"
        ref="header"
        :checkedCount="checkedCount"
      ></page-header>
    </div>
    <page-main
      style="margin-top: 20px;"
      @reset="resetTable"
      @getCardCount="getCardCount"
      :table="table"
      :isShow="isShow"
    ></page-main>
    <js-pagination
      :current-page="page.curPage"
      :page-size="page.pageSize"
      :page-total="page.pageTotal"
      :pageSizes="pageSizes"
      align="right"
      @change="handlePaginationChange"
    />
    <cart :visible.sync="visible" @close="close" @reset="resetTable"></cart>
  </div>
</template>

<script>
import Cart from './components/cart'
export default {
  name: 'digitalExhibitionHall-resFabric',
  components: {
    PageHeader: () => import('./components/header/index'),
    PageMain: () => import('./components/main'),
    Cart,
  },
  data() {
    return {
      isShow: false,
      visible: false,
      table: [],
      page: {
        curPage: 1,
        pageSize: 8,
        pageTotal: 0,
      },
      pageSizes: [8, 20, 40, 80, 100],
      queryParams: {},
      checkedCount: 0,
    }
  },
  mounted() {
    this.getCardCount()
  },
  methods: {
    getCardCount() {
      this.$api.resFabricDemandCartCountApi().then((res) => {
        this.checkedCount = res.body
      })
    },
    openCart() {
      this.visible = true
    },
    close() {
      this.visible = false
    },
    resetTable() {
      this.reset()
      this.queryData()
      this.getCardCount()
    },
    // 分页查询
    handlePaginationChange(val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total,
      }
      this.queryData()
    },
    // 加载表格数据
    handleSubmit(form) {
      this.reset()
      this.queryParams = form
      this.queryData()
    },
    queryData() {
      this.getCardCount()
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      this.$api
        .resFabricInfoPageList({
          ...this.queryParams,
          ...this.page,
        })
        .then((res) => {
          loading.close()
          this.page.pageTotal = res.body.count
          this.table = res.body.data
          if (this.table.length > 0) {
            this.table.map((e) => {
              let listImageUrl = [e.imageUrl]
              listImageUrl = listImageUrl.concat(
                e.fabricInfoList || []
              )
              e.listImageUrl = listImageUrl
            })
            this.isShow = true
          } else {
            this.isShow = false
          }
        })
        .catch(() => {
          loading.close()
        })
    },
    reset() {
      this.page = {
        curPage: 1,
        pageSize: 8,
        pageTotal: 0,
      }
    },
  },
}
</script>
<style lang="scss"></style>
